import { Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class ConfigGeneralMenuService {
  getMenu(): SubMenu {
    return {
      root: { label: 'menu.config-general', routerLink: AppRoutes.ConfigGeneral.root },
      items: [
        { label: 'menu.sdl-feedback', routerLink: AppRoutes.ConfigGeneral.root },
        { label: 'menu.facturation', routerLink: AppRoutes.ConfigGeneral.Facturation },
        { label: 'menu.upload-api', routerLink: AppRoutes.ConfigGeneral.UploadApi },
        { label: 'menu.url-access-general', routerLink: AppRoutes.ConfigGeneral.UrlAccessGeneral },
        { label: 'menu.generix-email-status', routerLink: AppRoutes.ConfigGeneral.GenerixEmailStatus },
        { label: 'announcements.title', routerLink: AppRoutes.ConfigGeneral.Announcements },
      ],
    };
  }
}
